
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Card',
  props: {
    title: String,
  },
  methods: {
    hasFooter() {
      return !!(this.$slots.footer && this.$slots.footer());
    },
  },
});
